import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportUnitsWithPermissionTypes } from "redux/reducers/Reports/reportUnitsWithPermission/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_UNITS_WITH_PERMISSION_FILTERS } = reportUnitsWithPermissionTypes;

export const getReportUnitsWithPermissionAction = ({ station, isPdf = true }) => {
  const token = localStorage.getItem('crm-user');
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/units/report-unitsWithPermission/${station.id}?pdf=${isPdf}`;
  const fileName = `Reporte_Unidades_Con_Permisos_${station.name}.${isPdf ? "pdf" : "xlsx"}`;

  return async dispatch => {
    dispatch(startRequestComp('loadingUnitsWithPermission'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingUnitsWithPermission'));
    }
  };
};

export const setReportUnitsWithPermissionFilters = (key = "", value) => ({
  type: SET_UNITS_WITH_PERMISSION_FILTERS,
  payload: { key, value }
});
